import React from 'react';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';

interface SketchPageShellProps {
  className?: string;
  children: React.ReactNode;
}

export const SketchPageShell: React.FC<SketchPageShellProps> = ({ className, children }) => {
  const { isSketchy } = useDesignMode();

  return (
    <div
      className={classNames(
        isSketchy ? 'paper-bg min-h-full text-[var(--color-text)]' : 'bg-[var(--color-bg)] text-[var(--color-text)]',
        className
      )}
    >
      {children}
    </div>
  );
};

interface SketchNavBarProps {
  className?: string;
  children: React.ReactNode;
}

export const SketchNavBar: React.FC<SketchNavBarProps> = ({ className, children }) => {
  const { isSketchy } = useDesignMode();

  return (
    <nav
      className={classNames(
        'sticky top-0 z-50 relative',
        isSketchy
          ? 'nav-bar-sketchy px-4 sm:px-6 lg:px-8'
          : 'bg-[var(--color-surface)] shadow-sm border-b border-[var(--color-border)] px-4 sm:px-6 lg:px-8',
        className
      )}
    >
      {children}
    </nav>
  );
};
